import Routes from './routes';
import { ThemeProvider as AppThemeProvider } from './hooks/useAppTheme';
import AnimatedBackground from './common/AnimatedBackground';
import MuiThemeBridge from './common/MuiThemeBridge';

const App = () => {
  return (
    <AppThemeProvider>
      <MuiThemeBridge>
        <AnimatedBackground />
        <Routes />
      </MuiThemeBridge>
    </AppThemeProvider>
  );
};

export default App;
